export default {
      id: "home-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#home",
      toString: function () {
        return this.url;
      }
    }